__turbopack_context__.v({
  "bayernMenu": "Header-module-scss-module__C6xC8G__bayernMenu",
  "header": "Header-module-scss-module__C6xC8G__header",
  "mainMenu": "Header-module-scss-module__C6xC8G__mainMenu",
  "open": "Header-module-scss-module__C6xC8G__open",
});
